/**
 * Tải 1 blob (CSV/XLSX...) trả về từ API xuống máy.
 * Gom về một chỗ vì mỗi màn tự viết lại đoạn createObjectURL + thẻ <a> ẩn,
 * và các bẫy trình duyệt bên dưới rất dễ quên.
 */
export function downloadBlob(data: BlobPart, filename: string, type = "text/csv") {
    const url = URL.createObjectURL(new Blob([data], { type }));
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    // Firefox bỏ qua click trên thẻ chưa gắn vào DOM, còn Safari huỷ tải
    // nếu revoke ngay → gắn vào DOM, click, rồi dọn ở tick sau.
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }, 0);
}

export default downloadBlob;
